export default "__VITE_ASSET__B_V2BlMx__"